<template>
    <DsModal
        data-qa="decision-diamond-debug-modal"
        class="dd-debug-modal"
        show-close
        :title="$t('funnel.edit.decision.diamond.button.debug.text')"
        :is-open="isOpen"
        size="fluid"
        @close="closeModal"
    >
        <template #default>
            <DsPlaceholder
                :loading="tableStatus === $options.LOADING"
                :rows="placeHolderRows"
                data-qa="decision-diamond-debug-placeholder"
            />

            <DecisionsTable
                v-if="tableStatus === $options.SUCCESS"
                :decisions="decisions"
                data-qa="decision-diamond-debug-decisions-table"
            />

            <DsTabset>
                <DsTab
                    :label="$t('funnel.debug.draft')"
                    :action="() => selectedTab = $options.TAP_SET_SELECTION.DRAFT"
                    :selected="selectedTab === $options.TAP_SET_SELECTION.DRAFT"
                    data-qa="decision-diamond-debug-tab-draft"
                >
                    <section v-if="tableStatus === $options.SUCCESS">
                        <OuterInnerTable
                            :rule-group-outer-inner="ruleGroupOuterInnerDraft"
                            data-qa="decision-diamond-debug-rule-group-outer-inner-draft"
                        />

                        <RuleTable
                            :rules="ruleDraft"
                            data-qa="decision-diamond-debug-rule-draft"
                        />

                        <RuleValueTable
                            :rule-values="ruleValueDraft"
                            data-qa="decision-diamond-debug-rule-value-draft"
                        />
                    </section>
                </DsTab>

                <DsTab
                    :label="$t('funnel.debug.published')"
                    :action="() => selectedTab = $options.TAP_SET_SELECTION.PUBLISHED"
                    :selected="selectedTab === $options.TAP_SET_SELECTION.PUBLISHED"
                    data-qa="decision-diamond-debug-tab-published"
                >
                    <section v-if="tableStatus === $options.SUCCESS">
                        <OuterInnerTable
                            :rule-group-outer-inner="ruleGroupOuterInnerPublished"
                            data-qa="decision-diamond-debug-rule-group-outer-inner-published"
                        />

                        <RuleTable
                            :rules="rulePublished"
                            data-qa="decision-diamond-debug-rule-published"
                        />

                        <RuleValueTable
                            :rule-values="ruleValuePublished"
                            data-qa="decision-diamond-debug-rule-value-published"
                        />
                    </section>
                </DsTab>
            </DsTabset>
        </template>
    </DsModal>
</template>

<script>
import { getDebugDataDump } from './decision.api';
import {
    SUCCESS,
    LOADING,
    ERROR,
    IDLE,
} from '@/components/shared/constants/loadingStatuses.constants';
import DecisionsTable from './DecisionsTable.vue';
import OuterInnerTable from './OuterInnerTable.vue';
import RuleTable from './RuleTable.vue';
import RuleValueTable from './RuleValueTable.vue';
import moment from 'moment-timezone';

export const TAP_SET_SELECTION = {
    DRAFT: 'Draft',
    PUBLISHED: 'Published',
};

export default {
    LOADING,
    SUCCESS,
    ERROR,
    components: {
        DecisionsTable,
        OuterInnerTable,
        RuleTable,
        RuleValueTable,
    },
    TAP_SET_SELECTION,
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        decisionIds: {
            type: Array,
            required: true,
        },
    },
    emits: ['close-dd-debug-modal'],
    data() {
        return {
            decisions: [],
            ruleGroupInnerDraft: [],
            ruleGroupOuterDraft: [],
            ruleGroupOuterInnerDraft: [],
            ruleGroupOuterInnerPublished: [],
            ruleDraft: [],
            ruleValueDraft: [],
            rulePublished: [],
            ruleValuePublished: [],
            tableStatus: IDLE,
            selectedTab: TAP_SET_SELECTION.DRAFT,
            placeHolderRows: [
                { height: '1.5rem', boxes: [1, 1, 1, 1, 1] },
                { height: '1.5rem', boxes: [1] },
                { height: '1.5rem', boxes: [1] },
                { height: '1.5rem', boxes: [1] },
            ],
        };
    },

    mounted() {
        this.loadDebugDataDump();
    },

    methods: {
        async loadDebugDataDump() {
            this.tableStatus = LOADING;

            try {
                const params = new URLSearchParams({
                    decisionIds: this.decisionIds.join(','),
                }).toString();

                const dataDump = await getDebugDataDump(params);
                const ruleGroupOuterPublished = dataDump.ruleGroupOuterPublished.map(this.fixNullValues);
                const ruleGroupInnerPublished = dataDump.ruleGroupInnerPublished.map(this.fixNullValues);
                const ruleGroupOuterDraft = dataDump.ruleGroupOuterDraft.map(this.fixNullValues);
                const ruleGroupInnerDraft = dataDump.ruleGroupInnerDraft.map(this.fixNullValues);

                this.ruleGroupOuterInnerDraft = [ruleGroupOuterDraft, ruleGroupInnerDraft];
                this.ruleGroupOuterInnerPublished = [ruleGroupOuterPublished, ruleGroupInnerPublished];
                this.decisions = dataDump.decisions.map(this.fixNullValues);
                this.ruleDraft = dataDump.ruleDraft.map(this.fixNullValues);
                this.ruleValueDraft = dataDump.ruleValueDraft.map(this.fixNullValues);
                this.rulePublished = dataDump.rulePublished.map(this.fixNullValues);
                this.ruleValuePublished = dataDump.ruleValuePublished.map(this.fixNullValues);

                this.tableStatus = SUCCESS;
            } catch (e) {
                this.tableStatus = ERROR;
            }
        },

        closeModal() {
            this.$emit('close-dd-debug-modal');
        },

        fixNullValues(data) {
            const mappedObject = {};

            Object.keys(data).forEach((key) => {
                if (!!data[key] && key === 'DateCreated' || key === 'LastUpdated') {
                    mappedObject[key] = moment(data[key]).format('M/D/YYYY');
                } else {
                    mappedObject[key] = data[key] || '';
                }
            });

            return mappedObject;
        },
    },
};
</script>
<style scoped>
.dd-debug-modal :deep(.tabset .tab-content) {
    position: inherit;
    left: 0;
    top: 0;
    clear: both;
    visibility: visible;
}
</style>
